interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionText,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900/60 px-6 py-16 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-800">
        <i className={`${icon} text-2xl text-primary-400`} />
      </span>
      <h3 className="font-heading text-base font-semibold text-foreground-100">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
        >
          {actionText}
        </button>
      )}
    </div>
  );
}